import bitcoin from "../imgz/bitcoin pc done.png";
import blog from "../imgz/mindzbook phone done.png";
import netflix from "../imgz/mindmovie pc.png";
import amazon from "../imgz/amazon pc done.png";
import kivengi from "../imgz/kivengi.jpg";
import shehe from "../imgz/chabai.jpg";
import dommy from "../imgz/dommy.jpg";
import rahma from "../imgz/rahma.jpg";
import gama from "../imgz/gamaz.jpg";

export const navItems = [
  { name: "About", link: "about" },
  { name: "Projects", link: "projects" },
  { name: "Testimonials", link: "testimonials" },
  { name: "Contact", link: "contact" },
];

export const gridItems = [
  {
    id: 1,
    title: "We prioritize client collaboration, fostering open communication ",
    description: "",
    className: "earth",
    imgClassName: "w-full h-full",
    titleClassName: "earthTitle",
    img: "../svgs/b1.svg",
    spareImg: "",
  },
  
  {
    id: 2,
    title: "We are very flexible with time zone communications",
    description: "",
    className: "timezone",
    imgClassName: "",
    titleClassName: "timezonettle",
    img: "",
    spareImg: "",
  },
  {
    id: 3,
    title: "Our tech stack",
    description: "We constantly try to improve",
    className: "techstack",
    imgClassName: "",
    titleClassName: "techstacktitle",
    img: "",
    spareImg: "",
  },
  {
    id: 4,
    title: "Tech enthusiast with a passion for development.",
    description: "",
    className: "techenthusiast",
    imgClassName: "",
    titleClassName: "techenthusiasttitle",
    img: "../svgs/grid.svg",
    spareImg: "../svgs/b4.svg",
  },

  {
    id: 5,
    title: "Do you want to start a project together?",
    description: "",
    className: "jslibrary",
    imgClassName: "",
    titleClassName: "jslibraryyiyle",
    img: "",
    spareImg: "",
 
  },
  {
    id: 6,      
    title: "Currently building Interesting Stuffs",
    description: "The Inside Scoop",
    className: "together",
    imgClassName: "absolute right-0 bottom-0 md:w-96 w-60",
    titleClassName: "togethertitle",
    img: "../svgs/b5.svg",
    spareImg: "../svgs/grid.svg",
  },
];

export const projects = [
  {
    id: 1,
    title: "3D Solar System Planets to Explore",
    des: "Explore the wonders of our solar system with this captivating 3D simulation of the planets using Three.js.",
    img: "../svgs/p1.svg",
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/fm.svg"],
    link: "/ui.earth.com",
  },
  {
    id: 2,
    title: "Yoom - Video Conferencing App",
    des: "Simplify your video conferencing experience with Yoom. Seamlessly connect with colleagues and friends.",
    img: "../svgs/p2.svg",
    iconLists: ["../svgs/next.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/stream.svg", "../svgs/c.svg"],
    link: "/ui.yoom.com",
  },
  {
    id: 3,
    title: "AI Image SaaS - Canva Application",
    des: "A REAL Software-as-a-Service app with AI features and a payments and credits system using the latest tech stack.",
    img: "../svgs/p3.svg",
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/c.svg"],
    link: "/ui.aiimg.com",
  },
  {
    id: 4,
    title: "Animated Apple Iphone 3D Website",
    des: "Recreated the Apple iPhone 15 Pro website, combining GSAP animations and Three.js 3D effects..",
    img: "../svgs/p4.svg",
    iconLists: ["../svgs/next.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/gsap.svg"],
    link: "/ui.apple.com",
  },
  {
    id: 5,
    title: "Bitcoin investment App",
    des: "Welcome to CryptoKafnex, your premier destination for smart Bitcoin investments... ",
    img: bitcoin,
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/fm.svg"],
    link: "https://bitcoin-38ac3.web.app",
  },
  {
    id: 6,
    title: "Blog website",
    des: "Welcome to your ultimate solution for creating and managing dynamic blogs with ease. Our web app ....",
    img: blog,
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/fm.svg"],
    link: "https://mindz-582bb.web.app/",
  },
  {
    id: 7,
    title: "Movie streaming website",
    des: "Welcome to Netflix clone, your go-to destination for endless entertainment. Dive into a vast library of movies....",
    img: netflix,
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/fm.svg"],
    link: "https://netflix-clone-92105.web.app",
  },
  {
    id: 8,
    title: "E-commerce website",
    des: "Welcome to Amazon clone, your go-to destination for inlimited shopping. Dive into a vast library of choices and goods on demand,...",
    img: amazon,
    iconLists: ["../svgs/re.svg", "../svgs/tail.svg", "../svgs/ts.svg", "../svgs/three.svg", "../svgs/fm.svg"],
    link: "https://angelo-4bfl.onrender.com",
  },
];

export const testimonials = [
  {
    quote:
      "Mastermindz Tech's professionalism, dedication, and enthusiasm for development were impressive throughout our project. They delivered exceptional results that elevated our website and brand.",
    name: "Kivengi Jr",
    title: "Director of Angelo Wellness",
    img: kivengi,
  },
  {
    quote:
      "The website Mastermindz Tech built for my business is visually stunning, highly functional, and user-friendly. Their professionalism and technical expertise boosted my online presence and attracted new customers.",
    name: "Deogratius Gamma",
    title: "Chief Medical Doctor",
    img: gama,
  },
  {
    quote:
      "Mastermindz Tech brought my vision to life with precision, delivering a sleek and intuitive mobile app. Their expertise greatly enhanced my business operations.",
    name: "Dominic Modest",
    title: "Director of D.M.M CARS",
    img: dommy,
  },
    {
    quote:
      "The desktop app Mastermindz Tech developed for us is robust and user-friendly, streamlining our operations. Their innovative solutions exceeded our expectations.",
    name: "Yusufu Chabai",
    title: "Director of Chabai Insurance",
    img: shehe,
  },
  {
    quote:
      "Mastermindz Tech created an elegant and feature-packed fashion designer app that transformed my business. Their creativity and responsiveness were exceptional.",
    name: "Rahma Omary",
    title: "Director of Beauty Designs",
    img: rahma,
  },
];

export const companies = [
  {
    id: 1,
    name: "cloudinary",
    img: "../svgs/cloud.svg",
    nameImg: "../svgs/cloudName.svg",
  },
  {
    id: 2,
    name: "appwrite",
    img: "../svgs/app.svg",
    nameImg: "../svgs/appName.svg",
  },
  {
    id: 3,
    name: "HOSTINGER",
    img: "../svgs/host.svg",
    nameImg: "../svgs/hostName.svg",
  },
  {
    id: 4,
    name: "stream",
    img: "../svgs/s.svg",
    nameImg: "../svgs/streamName.svg",
  },
  {
    id: 5,
    name: "docker.",
    img: "../svgs/dock.svg",
    nameImg: "../svgs/dockerName.svg",
  },
];

export const workExperience = [
  {
    id: 1,
    title: "Frontend Website Engineer",
    desc: "Assisted in the development of a web-based platform using React.js, enhancing interactivity.",
    className: "md:col-span-2",
    thumbnail: "../svgs/exp1.svg",
  },
  {
    id: 2,
    title: "Mobile App Dev - JSM Tech",
    desc: "Designed and developed mobile app for both iOS & Android platforms using React Native.",
    className: "md:col-span-2", // change to md:col-span-2
    thumbnail: "../svgs/exp2.svg",
  },
  {
    id: 3,
    title: "Freelance App Dev Project",
    desc: "Led the dev of a mobile app for a client, from initial concept to deployment on app stores.",
    className: "md:col-span-2", // change to md:col-span-2
    thumbnail: "../svgs/exp3.svg",
  },
  {
    id: 4,
    title: "Lead Frontend Developer",
    desc: "Developed and maintained user-facing features using modern frontend technologies.",
    className: "md:col-span-2",
    thumbnail: "../svgs/exp4.svg",
  },
];

export const socialMedia = [
  {
    id: 1,
    img: "../svgs/git.svg",
  },
  {
    id: 2,
    img: "../svgs/twit.svg",
  },
  {
    id: 3,
    img: "../svgs/link.svg",
  },
];
